import { ApolloProvider } from "@apollo/client";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import API from "./api/API";
import Root from "./Root";
import store from "./store/store";
import "./style/index.scss";
import "./style/tailwind.css";

// Notifications.con({
//     placement: "topRight",
// });

ReactDOM.render(
    <ApolloProvider client={API.instance}>
        <Provider store={store}>
            {/* @ts-ignore */}
            <Root />
        </Provider>
    </ApolloProvider>,
    document.getElementById("root")
);
